var $cca4d11f6d729c6a$exports = {};
class $cca4d11f6d729c6a$var$Thing {
    constructor(color, size, digital){
        this.color = color;
    }
    show() {
        console.log("showing...");
    }
    take() {
        console.log("taking..");
    }
}
class $cca4d11f6d729c6a$var$Box extends $cca4d11f6d729c6a$var$Thing {
    show() {
        console.log(`here is the ${this.color} box!`);
    }
}
const $cca4d11f6d729c6a$var$box = new $cca4d11f6d729c6a$var$Box("black", "L", true);
$cca4d11f6d729c6a$var$box.show();
$cca4d11f6d729c6a$var$box.take();
console.log("newest");


//# sourceMappingURL=index.aba697b4.js.map
